import { myFetch, HttpMethod } from './baseService';

export interface TipoMascota {
  tma_codigo: string;
  tma_nombre: string;
  tma_estatus?: string;
  tma_estatus_nombre?: string;
}

export interface TipoMascotaResponse {
  code: string;
  message: string;
  object_: TipoMascota[];
}

export const obtenerTiposMascota = async () => {
  const response = await myFetch<TipoMascotaResponse>(
    'tipo_mascota/ObtenerTodos',
    HttpMethod.POST,
    {}
  );

  return response;
};

